
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { FileText, Image, Video, Mic, FileCheck, Copy, UserCheck } from "lucide-react";

interface DetectionType {
  title: string;
  icon: any;
  href: string;
}

const detectionTypes: DetectionType[] = [
  { title: "Text Analysis", icon: FileText, href: "/text-analysis" },
  { title: "Image Analysis", icon: Image, href: "/image-analysis" },
  { title: "Video Analysis", icon: Video, href: "/video-analysis" },
  { title: "Voice Analysis", icon: Mic, href: "/voice-analysis" },
  { title: "Document Analysis", icon: FileCheck, href: "/document-analysis" },
  { title: "Plagiarism Check", icon: Copy, href: "/plagiarism-check" },
  { title: "Proxy Interview", icon: UserCheck, href: "/proxy-interview" },
];

const DetectionTypes = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Detection Types</CardTitle>
        <CardDescription>Quick access to all analysis tools</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {detectionTypes.map((item, i) => (
            <Link
              key={i}
              to={item.href}
              className="flex flex-col items-center p-4 rounded-lg border hover:bg-accent/50 transition-colors"
            >
              <div className="p-2 rounded-full bg-fraudeye-accent/10 mb-3">
                <item.icon className="h-6 w-6 text-fraudeye-accent" />
              </div>
              <span className="text-sm font-medium text-center">{item.title}</span>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default DetectionTypes;
